var MyHealthClinic = MyHealthClinic || {};

MyHealthClinic.Config = function () {
    return {};
}();
